import React, { useState, useEffect, useRef } from 'react';
import AdminAIChat from './AdminAIChat';

export default function FloatingAIChat({}) {
    const [isOpen, setIsOpen] = useState(false);
    const styles = {
        container: {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
        },
        button: {
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            fontSize: '30px',
            cursor: 'pointer',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        },
        chatWrapper: {
            width: '350px',
            height: '500px',
            marginBottom: '10px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            borderRadius: '8px',
            overflow: 'hidden',
            backgroundColor: '#fff',
            display: 'flex',
            padding: 10,
        }
    };

    return (
        <div style={styles.container}>
            {isOpen && (
                <div style={styles.chatWrapper}>
                    <AdminAIChat />
                </div>
            )}
            <button
                style={styles.button}
                onClick={() => setIsOpen(!isOpen)}
                title={isOpen ? "Close Chat" : "Open Chat"}
            >
                {isOpen ? '×' : '💬'}
            </button>
        </div>
    );
}